import { Dimensions, StyleSheet } from 'react-native';

export default StyleSheet.create({
  modalContainer: { paddingHorizontal: 0 },
  modalContent: { paddingBottom: 30 },
  errorContainerStyle: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    height: Dimensions.get('window').height * 0.75,
    paddingHorizontal: 16.2,
  }),
  titleStyle: { fontSize: 25, lineHeight: 31.2 },
  descriptionStyle: {
    fontSize: 18.7,
    lineHeight: 22.9,
    textAlign: 'center',
  },
  textContainerStyle: { flex: 1, justifyContent: 'center', alignItems: 'center' },
});
